import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronLeft, ChevronRight, X } from 'lucide-react';
import { getImageUrl } from '../config/api';
import './PhotoGallery.css';

export function PhotoLightbox({ photos, index, onClose, onNavigate, footer }) {
  const photo = photos[index];

  useEffect(() => {
    const onKey = (e) => {
      if (e.key === 'Escape') onClose();
      if (e.key === 'ArrowRight') onNavigate(1);
      if (e.key === 'ArrowLeft') onNavigate(-1);
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose, onNavigate]);

  if (!photo) return null;

  return createPortal(
    <motion.div
      className="photo-lightbox"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      onClick={onClose}
    >
      <button type="button" className="photo-lightbox-close" onClick={onClose} aria-label="Close">
        <X size={28} />
      </button>
      <button
        type="button"
        className="photo-lightbox-nav photo-lightbox-prev"
        onClick={(e) => {
          e.stopPropagation();
          onNavigate(-1);
        }}
        aria-label="Previous photo"
      >
        <ChevronLeft size={36} />
      </button>
      <div className="photo-lightbox-stage" onClick={(e) => e.stopPropagation()}>
        <AnimatePresence mode="wait">
          <motion.img
            key={photo.id}
            src={getImageUrl(photo.image_url)}
            alt={photo.caption || photo.albumName || 'Gallery photo'}
            initial={{ opacity: 0, scale: 0.98 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.98 }}
            transition={{ duration: 0.2 }}
          />
        </AnimatePresence>
        <div className="photo-lightbox-meta">
          <span className="photo-lightbox-counter">
            {index + 1} / {photos.length}
          </span>
          {photo.albumName && <span className="photo-lightbox-album">{photo.albumName}</span>}
          {photo.caption && <p className="photo-lightbox-caption">{photo.caption}</p>}
        </div>
        {footer}
      </div>
      <button
        type="button"
        className="photo-lightbox-nav photo-lightbox-next"
        onClick={(e) => {
          e.stopPropagation();
          onNavigate(1);
        }}
        aria-label="Next photo"
      >
        <ChevronRight size={36} />
      </button>
    </motion.div>,
    document.body
  );
}
